import { useMemo } from 'react'
import { isEmpty, defaultTo, path } from 'ramda'

/**
 * returns validator properties based on schema
 * @param {Object} schema
 * @returns {Object}
 * @example
 *    const schema = yup.string().required().max(10)
 *
 *    useValidators(schema)
 *    //=> { type: 'string', required: true, max: 10 }
 */
const useValidators = (schema) => {
  const stringifiedContext = JSON.stringify(schema.context)

  // this one needs to stay, must update when context changes
  /* eslint-disable react-hooks/exhaustive-deps */
  return useMemo(() => {
    if (!schema) {
      throw new Error('No schema provided to input field')
    }

    const { tests, type } = schema
      .resolve({ context: schema.context })
      .describe()

    if (isEmpty(tests)) return { type }

    return tests.reduce(
      (acc, value) => ({
        ...acc,
        [value.name]: defaultTo(true, path(['params', value.name], value)),
      }),
      { type }
    )
  }, [schema, stringifiedContext])
}

export default useValidators
